import { useState } from "react";
import axios from "axios";
import { CheckCircle2, Loader2, Mail, TrendingDown, TrendingUp } from "lucide-react";
import { API } from "../../config";

const AREAS = ["ai", "speed", "security"];

export const ProgressBox = ({ pr, ui, issueText }) => {
  const up = AREAS.filter((a) => (pr.delta[a] || 0) > 0);
  const down = AREAS.filter((a) => (pr.delta[a] || 0) < 0);
  return (
    <div className="mt-6 rounded-xl border border-emerald-500/30 bg-emerald-500/[0.06] p-4" data-testid="congrats-progress">
      <p className="text-sm font-bold text-white mb-2">
        {ui.sinceLast} {new Date(pr.previous_ts).toLocaleDateString(ui.locale)}:{" "}
        <span className={pr.overall_delta >= 0 ? "text-emerald-300" : "text-red-300"} data-testid="congrats-progress-delta">
          {pr.overall_delta >= 0 ? "+" : ""}{pr.overall_delta} {ui.points}
        </span>
      </p>
      {pr.fixed.length > 0 && (
        <ul className="space-y-1 text-sm text-emerald-200 mb-2" data-testid="congrats-progress-fixed">
          {pr.fixed.map((i) => <li key={i.area + i.label} className="flex gap-2"><CheckCircle2 className="w-4 h-4 mt-0.5 shrink-0" />{ui.fixedPrefix}: {issueText(i)}</li>)}
        </ul>
      )}
      <div className="flex flex-wrap gap-3 text-xs">
        {up.map((a) => <span key={a} className="inline-flex items-center gap-1 text-emerald-300"><TrendingUp className="w-3.5 h-3.5" />{ui[a]} +{pr.delta[a]}</span>)}
        {down.map((a) => <span key={a} className="inline-flex items-center gap-1 text-red-300"><TrendingDown className="w-3.5 h-3.5" />{ui[a]} {pr.delta[a]}</span>)}
      </div>
    </div>
  );
};

export const EmailResult = ({ checkId, ui }) => {
  const [email, setEmail] = useState("");
  const [consent, setConsent] = useState(false);
  const [state, setState] = useState("idle");
  const send = async (e) => {
    e.preventDefault();
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email.trim())) { setState("invalid"); return; }
    setState("busy");
    try {
      await axios.post(`${API}/funnel-tools/quick-check/email`, { check_id: checkId, email: email.trim(), marketing_consent: consent });
      setState("sent");
    } catch { setState("error"); }
  };
  if (state === "sent") return <p className="mt-6 text-sm text-emerald-300 flex gap-2" data-testid="congrats-email-sent"><CheckCircle2 className="w-4 h-4 mt-0.5" />{ui.emailSent}</p>;
  return (
    <form noValidate onSubmit={send} className="mt-6 rounded-xl border border-white/10 bg-white/[0.03] p-4" data-testid="congrats-email-form">
      <p className="text-sm font-bold text-white mb-1 flex items-center gap-2"><Mail className="w-4 h-4" />{ui.emailTitle}</p>
      <p className="text-xs text-white/60 mb-3">{ui.emailSub}</p>
      <div className="flex flex-col sm:flex-row gap-2">
        <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder={ui.emailPh}
          className="flex-1 px-3 py-2.5 rounded-lg bg-white text-gray-900 placeholder-gray-400 outline-none" data-testid="congrats-email-input" />
        <button type="submit" disabled={state === "busy"} className="px-5 py-2.5 rounded-lg bg-white/10 border border-white/20 text-white font-bold hover:bg-white/20 transition-colors inline-flex items-center justify-center gap-2" data-testid="congrats-email-submit">
          {state === "busy" && <Loader2 className="w-4 h-4 animate-spin" />}{ui.emailBtn}
        </button>
      </div>
      <label className="mt-3 flex items-start gap-2 text-xs text-white/60 cursor-pointer">
        <input type="checkbox" checked={consent} onChange={(e) => setConsent(e.target.checked)} className="mt-0.5 w-4 h-4 accent-[#2563eb]" data-testid="congrats-email-consent" />
        <span>{ui.emailConsent}</span>
      </label>
      {(state === "invalid" || state === "error") && <p className="mt-2 text-xs text-red-300" data-testid="congrats-email-error">{state === "invalid" ? ui.emailInvalid : ui.err}</p>}
    </form>
  );
};
